module.exports = __webpack_public_path__ + "static/6305-woodrose-48-31590e66149b00f5bc319be7048cd716.jpg";